import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import ReactDatatable from "@ashvin27/react-datatable";
import { toastAlert } from "../../lib/toastAlert";
import moment from 'moment';
import { HideCollectionSBT, SBTCollectionMaySent, getSBTtokenlist, updateSbtcollectionStatus } from '../../actions/users';
import axios from 'axios';
import Exportexcel from "../pdf/Excelexport"
import Exportpdf from "../pdf/Exportpdf"
import Exportcsv from "../pdf/Exportcsv"

const TokenList = () => {
    const [allcheck, setAllcheck] = useState(false);
    const [isPromoted, setisPromoted] = useState(false)
    const [userdet, setUser] = useState();
    const [exportdata, setExportdata] = useState([]);



    useEffect(() => {
        getTokenlist();
    }, [isPromoted])
    const getTokenlist = async () => {
        var test = await getSBTtokenlist();
        if (test.userValue.Success) {
            setUser(test.userValue.userValue);
            var ddd = test.userValue.userValue.map(({ _id, tokenOwnerDb, ...rest }) => {
                return rest
            })
            setExportdata(ddd)
        }
        else {
        }
    }

    const setMaySent = async (data) => {
        if (data?.target) {
            if (userdet.length > 0) {

                var resp = await SBTCollectionMaySent({ all: data.target.checked });
                if (resp?.Success) {
                    setAllcheck(!allcheck)
                    toastAlert("success", 'Success...Please wait for data refresh');
                    getTokenlist()
                }
                else
                    toastAlert("error", resp.msg)
            } else {
                toastAlert("error", "Subscribers are not yet")
            }
        } else {
            var payload = {
                email: data.email,
                maySent: !data.maySent
            }

            var resp = await SBTCollectionMaySent(payload);
            if (resp?.Success) {
                toastAlert("success", 'Success...Please wait for data refresh');
                getTokenlist()
            }
            else
                toastAlert("error", resp.msg)
        }

    }

    const deleteUser = async () => {
        var send = {
            Show: "Hide"
        }
        let handlemaychange = await HideCollectionSBT(send);
        if (handlemaychange.Success) {
            toastAlert("success", 'Collection Hide Succesfully');
            getTokenlist()
        }
        else {
            toastAlert("error", 'Error on Server');
        }
    }

    const Show = async () => {
        var send = {
            Show: "Show"
        }
        let handlemaychange = await HideCollectionSBT(send);
        if (handlemaychange.Success) {
            toastAlert("success", 'Collection is Visible Now');
            getTokenlist()
        }
        else {
            toastAlert("error", 'Error on Server');
        }
    }

    const handleChangemaysent = async (event) => {
        let { id, checked } = event.target;
        let handlemaychange = await updateSbtcollectionStatus({ email: id, maySentChecked: checked });
        if (handlemaychange.Success) {
            toastAlert("success", 'Selected');

            getTokenlist()

        }
        else {
            toastAlert("error", 'Error on Server');
        }
    }

    const ViewTokens = async (record) => {
        if (record.CollectionName && record.Address)
            window.location.href = "/ViewCollection/" + record.Address + "/" + String(record.CollectionName);
        else
            window.location.href = "/ViewCollection/" + record.Address + "/" + String(record.CollectionName);
    }

    const columns = [
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 100,
            align: "center",
            sortable: false,
            cell: record => {
                return (
                    <div className='text-center exchange_table_values'>
                        {record && <input type="checkbox" name={record.CollectionName} id={record.CollectionName} checked={record.MayChecked == "true" || record.MayChecked == true ? true : false} onChange={(event) => { handleChangemaysent(event) }} />}
                    </div>
                );
            }
        },
        {
            key: "ind",
            text: "SNO",
            className: "name",
            align: "center",
            sortable: true,
            cell: (row, index, column, id) =>
                <p className='text-center exchange_table_values'>{index + 1}</p>

        },
        {

            key: "CollectionName",
            text: "Collection Name",
            className: "CollectionName",
            align: "center",
            sortable: false,
            cell: (val) =>
                <p className='text-center exchange_table_values'>{val.CollectionName}</p>
        },
        {

            key: "Address",
            text: "Address",
            className: "Address",
            align: "center",
            sortable: false,
            cell: (val) =>
                <p className='text-center exchange_table_values'>{val.Address}</p>
        },
        {
            key: "Date",
            text: "Created At",
            className: "Date",
            align: "center",
            sortable: false,
            cell: record =>
                <div><p className='text-center exchange_table_values' >{moment(record.Date).format('MMMM,Do YYYY, hh:mm A')}</p></div>
        },
        {
            key: "deleted",
            text: "Hide/Show",
            className: "Date",
            align: "center",
            sortable: false,
            cell: record =>
                <div className='text-center exchange_table_values'><p>{(record.deleted == "true") ? "Visible" : "Hidden"}</p></div>
        },
        {
            key: "action",
            text: "View Collection",
            className: "action",
            width: 100,
            align: "center",
            sortable: false,
            cell: record => {
                return (
                    <div className='text-center exchange_table_values'>
                        <button
                            data-toggle="modal"
                            data-target="#update-template-modal"
                            className="btn btn-primary btn-sm"
                            onClick={() => ViewTokens(record)}

                            style={{ marginRight: '5px' }}
                        >
                            <i className="fa fa-eye"></i>
                        </button>
                    </div>
                );
            }
        },

    ];

    const config = {
        page_size: 5,
        length_menu: [10, 20, 50],
        filename: "Users",
        no_data_text: "No user found!",

        language: {
            length_menu: "Show _MENU_ result per page",
            filter: "Filter in records...",
            info: "Showing _START_ to _END_ of _TOTAL_ records",
            pagination: {
                first: "First",
                previous: <> Previous </>,
                next: <>Next</>,
                last: "Last",
            },
        },
        show_length_menu: true,
        show_filter: true,
        show_pagination: true,
        show_info: true,
        defaultSortAsc: true,
    };
    return (
        <>
            <Container fluid className="common_bg position-relative">
                <div className="liner"></div>
                <Row>
                    <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
                        <Sidebar />
                    </Col>
                    <Col xl={10} lg={12}>
                        <Header title={'SBT Collection'} />

                        <div className="common_page_scroller mt-5 pe-2">
                            <div className="page_header">
                                <h2>SBT Collection</h2>
                                <div>
                                    <div className="selection_sec">
                                        <div className="checkbox_sec_user">
                                            <span>SELECT ALL</span>
                                            <input type="checkbox" className='selectall ms-2' checked={allcheck} onChange={(e) => setMaySent(e)} />
                                        </div>

                                        <div>
                                            <button className="ms-3" variant="contained" onClick={() => deleteUser()} color="primary">Hide Collection</button>
                                        </div>
                                        <div>
                                            <button className="ms-3" variant="contained" onClick={() => Show()} color="primary">Show Collection</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="exchange_table_holder dashboard_box rounded-3 mt-4">
                                <ReactDatatable
                                    config={config}
                                    records={userdet}
                                    columns={columns}
                                />
                            </div>
                        </div>
                        <div className='bottom_btn_comp'>
                            <Exportexcel excelData={exportdata} fileName={'category'} />
                            <Exportpdf pdfData={exportdata} fileName={'category'} />
                            <Exportcsv csvData={exportdata} fileName={'category'} />
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default TokenList